module.exports = function() {
	return new Worker(__webpack_public_path__ + "5d85e78ed005bbd7cc7e.environment.wrkr.js");
};